//global.js 售后大屏 API 地址（as-web gateway）

export default {
  method: 'get',
  // 基础url前缀 — V0.3: /as-web/api/v1/
  baseUrl: 'https://aftersales.robotplusplus.com/as-web/api/v1/',
  //baseUrl:'http://39.100.74.73:5142/as-web/api/v1/',
  //baseUrl:'http://aftersales.robotplusplus.com/as-web/api/v1/',
  //baseUrl: 'https://rppiot.robotplusplus.com/rpp/',
  //baseUrl: 'https://rppaftersales.robotplusplus.com/as-web/api/v1/',
  // baseUrl: 'http://192.168.20.171:8080/as-web/api/v1/',
  headers: {
    'content-type': 'application/json',
    'Accept': '*/*',
  },
  data: {},
  timeout: 100000,
  responseType: 'json'
}
